"use strict";

var _ = require('lodash');
var Assign = require("object-assign");

/**
 * An object that wraps the wendys api menu response and has simple
 * helpers to make navigating the object easier.
 *
 * @param wendysMenuApi
 * @description property member initialization at bottom of constructor
 */
module.exports = function (wendysMenuApi) {
    var _self = this;

    this._wendysMenuApi = wendysMenuApi; //ask tommy - we might b able to just clone this

    this.getComboMenuItemIds = function () {
        return _.filter(_self._wendysMenuApi.menuLists.menuItems, function (item) {
            return item.comboMenuItemId;
        }).map(function (item) {
            return item.comboMenuItemId;
        });
    };

    /**
     * grabs the categories from the api response
     */
    this.getCategories = function () {

        return _.map(_self._wendysMenuApi.menuLists.menus[0].subMenus, function (subMenuId) {
            return _.find(_self._wendysMenuApi.menuLists.subMenus, function (subMenu) {
                return subMenu.subMenuId === subMenuId;
            });
        });
    };

    this.getOrderModes = function () {
        return _self._wendysMenuApi.menuLists.orderModes;
    };

    /**
     * gets menu items by subMenuId
     * @param subMenuId
     * @returns {Array} of menuItems from the api response
     */
    this.getMenuItemsBy = function (subMenuId) {

        //grab submenu
        var subMenu = findSubMenuById(subMenuId); //_.find(_self._wendysMenuApi.menuLists.subMenus, {"subMenuId": subMenuId});
        if (!subMenu) return [];

        return _.map(subMenu.menuItems, function (menuItemId) {
            return _.find(_self._wendysMenuApi.menuLists.menuItems, { menuItemId: menuItemId });
        });
    };

    /**
     * Gets ALL the menuItems that have the passed in salesItemId in salesItemIds array of each menuItem.
     * @param salesItemId
     * @returns {Array} array of menuItems, false if nothing found
     */
    this.getMenuItemBySalesItemId = function (salesItemId) {
        return _.filter(_self._wendysMenuApi.menuLists.menuItems, function (menuItem) {
            return _.includes(menuItem.salesItemIds, salesItemId);
        });
    };

    /**
     * retrieves the default modifiers from a list of defaultOptions
     * @param {Array.<Object>} defaultOptions Example: [{modifierGroupId: xx, modifierId: xx},..]
     * @returns {Array} array of default modifier objects
     */
    this.getDefaultModifiers = function (defaultOptions) {
        return defaultOptions.map(function (defaultOption) {
            var modifier = _self.getModifierById(defaultOption.modifierId);
            return Assign({}, defaultOption, modifier);
        });
    };

    this.getDefaultSelectionModifier = function (salesItem) {
        if (!salesItem || !salesItem.defaultOptions) return null;
        var modifierGroups = this.getModifierGroups(salesItem.modifierGroups);
        var selectionModifierGroup = this.getSelectionModifierGroup(modifierGroups);
        if (selectionModifierGroup && selectionModifierGroup[0]) {
            var defaultModifier = _.find(salesItem.defaultOptions, function (modifier) {
                return modifier.modifierGroupId === selectionModifierGroup[0].modifierGroupId;
            });
            if (defaultModifier) {
                return Assign({}, { modifierGroupId: selectionModifierGroup[0].modifierGroupId }, this.getModifierById(defaultModifier.modifierId));
            }
        }
        return null;
    };

    this.getSelectionModifierGroup = function (modifierGroups) {

        var selectionModifierGroups = [];

        modifierGroups.forEach(function (el) {
            if (el.displayCode === "SELECTION") {
                selectionModifierGroups.push(el);
            }
        });
        return selectionModifierGroups;
    };

    /**
     * retrieves the modifierGroups from a list of modifierGroupIds
     * @param {Array} modifierGroupIds
     * @returns {Array} array of modifierGroups
     */
    this.getModifierGroups = function (modifierGroupIds) {
        if (modifierGroupIds) {
            return modifierGroupIds.map(function (id) {
                return _self.getModifierGroup(id);
            });
        } else {
            return [];
        }
    };

    /**
     * retrieves the customization modifierGroups from product
     * @param {Array} modifierGroupIds
     * @returns {Array} array of modifierGroups
     */
    this.getCustomizationModifierGroups = function (modifierGroupIds) {
        var modifierGroups = this.getModifierGroups(modifierGroupIds);
        return _.filter(modifierGroups, { displayCode: 'CUSTOMIZATION' });
    };

    //TODO: get rid of this method
    this.getAllModifiersForItem = function (lineItem) {
        console.log("Please do not use this method, its relying on data provided from productDetail before combo refactor");
        var modifiers = [];
        var self = this;
        var lineItemClone = _.cloneDeep(lineItem);

        var salesItem = this.getSalesItemBy(lineItemClone.salesItemId);

        if (salesItem.defaultOptions) {
            salesItem.defaultOptions.forEach(function (defaultOption) {
                var modifier = self.getModifierById(defaultOption.modifierId);

                //remove the itemModifier from the default option so we end up with a final array of itemModifiers without defaults (below)
                var itemModifier = _.remove(lineItemClone.modifiers, { componentId: modifier.componentId })[0];
                if (itemModifier && itemModifier.customization) {
                    if (itemModifier.customization.actionType != 'NO') {
                        modifiers.push(modifier);
                    }
                } else {
                    console.log(itemModifier);
                    modifiers.push(modifier);
                }
            });
        }

        //add non-default options (ex: ketchup added to fries)
        if (lineItemClone.modifiers && lineItemClone.modifiers.length > 0) {
            lineItemClone.modifiers.forEach(function (el) {
                modifiers.push(self.getModifierById(el.modifierId));
            });
        }

        return modifiers;
    };

    //TODO: get rid of this method
    this.getComponentArray = function (lineItem) {
        console.log("Please do not use this method, its relying on data provided from productDetail before combo refactor");
        var components = [];
        var self = this;
        var lineItemClone = _.cloneDeep(lineItem);
        if (lineItemClone.modifiers && lineItemClone.modifiers.length > 0) {
            var salesItem = this.getSalesItemBy(lineItemClone.salesItemId);
            if (salesItem.defaultOptions) {
                salesItem.defaultOptions.forEach(function (defaultOption) {
                    var modifier = self.getModifierById(defaultOption.modifierId);

                    //remove the itemModifier from the default option so we end up with a final array of itemModifiers without defaults (below)
                    var itemModifier = _.remove(lineItemClone.modifiers, { componentId: modifier.componentId })[0];
                    if (itemModifier && itemModifier.customization) {

                        if (itemModifier.customization.actionType != 'NO') {
                            components.push({
                                id: itemModifier.customization.componentId,
                                quantity: itemModifier.customization.quantity || 1,
                                action: itemModifier.customization.action
                            });
                        }
                    } else {
                        components.push({
                            id: modifier.componentId,
                            quantity: 1
                        });
                    }
                });
            }

            //add non-default options (ex: ketchup added to fries)
            lineItemClone.modifiers.forEach(function (el) {
                components.push({
                    id: el.componentId,
                    quantity: el.customization ? el.customization.quantity : el.quantity,
                    action: el.customization ? el.customization.action : el.action
                });
            });
        }
        return components.length > 0 ? components : false;
    };

    this.getSelectionModifiers = function (modifierGroups) {

        var selectionModifiers = [];

        modifierGroups.forEach(function (el) {
            if (el.displayCode === "SELECTION") {
                selectionModifiers.push(el.modifiers);
            }
        });
        return selectionModifiers;
    };

    /**
     * get the submenu by id
     * @param {int} subMenuId
     * @returns {*}
     */
    this.getSubMenuBy = function (subMenuId) {
        return findSubMenuById(subMenuId);
    };

    /**
     * get menu item by id
     * @param id
     * @returns {*}
     */
    this.menuItemById = function (id) {
        return _.find(_self._wendysMenuApi.menuLists.menuItems, { menuItemId: id });
    };

    this.menuItemByComboId = function (id) {
        return _.find(_self._wendysMenuApi.menuLists.menuItems, { comboMenuItemId: id });
    };

    /**
     * creates a url to the appropriate environment path to a menu items image
     * hosted on the app.wendys.com site.
     * @param menuItemId
     * @returns {string, bool} url to menu items picture, false if not found
     */
    this.getMenuItemImageBy = function (menuItemId) {
        var cntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
        var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
        var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "medium";

        var menuItem = _self.menuItemById(menuItemId);
        var imgUri = false;
        if (menuItem) {
            if (!!menuItem.baseImageName) {
                // checking to see if there is a base image name
                // this use case is mainly for using group images for combos
                imgUri = require('../lib/config').urls.productGroupImageBase + menuItem.baseImageName + "_" + size + "_" + cntry + "_" + lang + ".jpg";
            } else {
                // this is fallback if, for combos, the base image does not exist
                // or if the menuItem is not a meal/combo
                var salesItem = _self.findSalesItemByMenuItemId(menuItemId);
                imgUri = _self.getProportionalProductImageBy(salesItem.productId, size, cntry, lang);;
            }
        }
        return imgUri;
    };

    this.getProductGroupHeroImageBy = function (menuItemId) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
        var cntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "US";
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

        var menuItem = _self.menuItemById(menuItemId);

        /* If menuItem.baseImageName; return SalesGroup Hero */
        if (menuItem && !!menuItem.baseImageName) return require('../lib/config').urls.productGroupHeroImageBase + menuItem.baseImageName + "_" + size + "_" + cntry + "_" + lang + ".jpg";

        /* Otherwise, return Menu Item Hero */
        if (menuItem) return this.getMenuItemProportionalHeroImageBy(menuItemId, size, cntry, lang);
    };

    /**
     * creates a url to the appropriate environment path to a menu items image
     * hosted on the app.wendys.com site.
     * @param id
     * @returns {string, bool} url to menu items picture, false if not found
     */
    this.getMenuItemProportionalImageBy = function (id) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
        var cntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "US";
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

        return buildProportionalImageUrl(id, size, cntry, lang);
    };

    /**
     * creates a url to the appropriate environment path to a menu items hero image
     * hosted on the app.wendys.com site.
     * @param menuItemId
     * @returns {string, bool} url to menu items picture, false if not found
     */
    this.getMenuItemProportionalHeroImageBy = function (menuItemId) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
        var cntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "US";
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

        var salesItem = _self.findSalesItemByMenuItemId(menuItemId);
        return salesItem ? buildProductProportionalHeroImageUrl(salesItem.productId, size, cntry, lang) : false;
    };

    this.getMenuItemHeroImageBy = function (salesItemId) {
        var salesItem = _self.getSalesItemBy(salesItemId);
        return salesItem ? buildProductHeroImageUrl(salesItem.productId) : false;
    };

    this.getCSOMenuItemImageBy = function (menuItemId) {
        var salesItem = _self.findSalesItemByMenuItemId(menuItemId);
        return salesItem ? buildCSOImageUrl(salesItem.productId) : false;
    };

    this.getProductImageBy = function (productId) {
        return this.buildImageUrl(productId);
    };

    this.getProductGroupImageUrlByMenuItemId = function (menuItemId, size, cntry, lang) {
        var menuItem = _self.menuItemById(menuItemId);

        if (menuItem && menuItem.baseImageName) {
            return _self.buildProductGroupImageUrl(menuItem.baseImageName, size, cntry, lang);
        }

        var salesItem = _self.findSalesItemByMenuItemId(menuItemId);
        return buildProportionalImageUrl(salesItem.productId, size, cntry, lang);
    };

    /**
     * Build image url for product groups
     * @param productGroupId - ID of product group to retrieve. This will typically come from the baseImageName on menuItem.
     * @param size
     * @param cntry
     * @param lang
     * @returns {string}
     */
    this.buildProductGroupImageUrl = function (productGroupId) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
        var cntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "US";
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

        var imageUrl = productGroupId + "_" + size + "_" + cntry + "_" + lang + ".jpg";
        var imageBase = require('../lib/config').urls.productGroupImageBase;
        return "" + imageBase + imageUrl;
    };

    this.getProportionalProductImageBy = function (productId) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "medium";
        var cntry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "US";
        var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en";

        return buildProportionalImageUrl(productId, size, cntry, lang);
    };

    this.getCSOProductImageBy = function (productId) {
        return buildCSOImageUrl(productId);
    };

    this.getCSOComponentImageBy = function (componentId) {
        //todo: pull this from config...
        return require('../lib/config').urls.images.csoComponents + componentId + '.png';
    };

    this.getCategoryImageBy = function (categoryId, country, language) {

        var locale = (country ? country : 'US') + '_' + (language ? language : 'en');
        var category = findSubMenuById(categoryId);
        return category && category.baseImageName ? require('../lib/config').urls.categoryImageBase + category.baseImageName + '_medium_' + locale + '.jpg' : false;
    };

    /**
     * @deprecated
     */
    this.getCSOCategoryImageBy = function (categoryId) {
        var cntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
        var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";

        var category = findSubMenuById(categoryId);
        return category && category.baseImageName ? require('../lib/config').urls.csoCategoryImageBase + category.baseImageName + "_large_" + cntry + "_" + lang + ".jpg" : false;
    };

    this.getCSOCategoryAccordionImageBy = function (categoryId) {
        var cntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
        var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";

        var category = findSubMenuById(categoryId);
        return category && category.baseImageName ? require('../lib/config').urls.csoCategoryImageBase + category.baseImageName + "_accordion_" + cntry + "_" + lang + ".jpg" : false;
    };

    this.getCSOBaseImageBy = function (baseImageName) {
        var cntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
        var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";

        return require('../lib/config').urls.csoCategoryImageBase + baseImageName + "_large_" + cntry + "_" + lang + ".png";
    };

    this.getLTOImageBy = function (ltoName) {
        var cntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "US";
        var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";

        var config = require('../lib/config');
        var urlRoot = config.urls.images.featuredItems;

        return "" + urlRoot + ltoName + "_large_" + cntry + "_" + lang + ".png";
    };

    this.isLTO = function (menuItemId) {
        var salesItem = _self.findSalesItemByMenuItemId(menuItemId);
        return salesItem ? salesItem.isLTO : false;
    };

    /**
     * gets sales item by salsItemId
     * @param {int} salesItemId
     */
    this.getSalesItemBy = function (salesItemId) {
        return _.find(_self._wendysMenuApi.menuLists.salesItems, { salesItemId: salesItemId });
    };

    /**
     * gets the menuPromoItem object
     * @returns {exports.getSiteMenuData.menuLists.menuPromoItem|*}
     */
    this.getMenuPromoItem = function () {
        return _self._wendysMenuApi.menuLists.menuPromoItem;
    };

    /**
     *
     * gets sales item by salsItemId
     * @param [int] input array of salesItemIds ex: [100,300,101..]
     * @returns [] of salesItem objects
     */
    this.getSalesItemsByIds = function (salesItemIds) {
        return _.chain(salesItemIds).map(function (salesItemId) {
            return _self.getSalesItemBy(salesItemId);
        }).filter(function (el) {
            return el != undefined;
        }).value();
    };

    this.getModifierGroup = function (modifierGroupId) {
        var originalModifierGroup = _.find(_self._wendysMenuApi.menuLists.modifierGroups, { modifierGroupId: modifierGroupId });
        var modifierGroup = {};
        _.assign(modifierGroup, originalModifierGroup);
        var modifiers = [];
        if (modifierGroup.modifiers) {
            modifierGroup.modifiers.forEach(function (v) {
                modifiers.push(_self.getModifierById(v));
            });
        }
        modifierGroup.modifiers = modifiers;
        return modifierGroup;
    };

    this.getModifierGroupData = function (modifierGroupId) {
        return _.find(_self._wendysMenuApi.menuLists.modifierGroups, { modifierGroupId: modifierGroupId });;
    };

    this.getModifierById = function (modifierId) {
        return _.find(_self._wendysMenuApi.menuLists.modifiers, { modifierId: modifierId });
    };

    this.getModifierByComponentId = function (componentId) {
        var modifier = _.find(_self._wendysMenuApi.menuLists.modifiers, { componentId: componentId });
        return _.cloneDeep(modifier);
    };

    this.getModifierActions = function () {
        var modifierActions = {};
        _self._wendysMenuApi.menuLists.modifierActions.forEach(function (el) {
            var key = el.name.toUpperCase();
            modifierActions[key] = el;
        });
        return modifierActions;
    };

    this.getModifierActionNameByAction = function (action) {
        return _.find(_self._wendysMenuApi.menuLists.modifierActions, { action: action });
    };

    /**
     * Retrieves required modifierGroups that are missing from the input items
     *
     * @param {Array<{salesItemId: number, modifiers: array>} array of sales items and selected modifiers
     * @returns {Array<{salesItem: object, modifiers: array, missingModifierGroups: array, idx: number>} array of salesItems with corresponding missing modifiers and index position of original input
     */
    this.requiredModifiersMissing = function (items) {
        console.warn('Method deprecated: please use getMissingRequiredModifiers which does not use itemOptionsGroupId');
        var items = _.cloneDeep(items);

        return _.chain(items).map(function (item, idx) {
            var salesItem = _self.getSalesItemBy(item.salesItemId);
            var missingModifierGroups = [];

            if (salesItem.modifierGroups) {
                salesItem.modifierGroups.forEach(function (modifierGroupId) {
                    var modifierGroup = _self.getModifierGroup(modifierGroupId);
                    var requiredCount = modifierGroup.minimumItems;

                    if (requiredCount > 0) {
                        var modifiers = _.filter(item.modifiers, { itemOptionGroupId: modifierGroupId });
                        var defaultOptions = _.filter(salesItem.defaultOptions, { modifierGroupId: modifierGroupId });

                        var modifierCount = 0;

                        if (modifiers) {
                            modifierCount = _.reduce(modifiers, function (sum, next) {
                                return sum + (next.quantity || 0);
                            }, 0);
                        } else if (defaultOptions) {
                            modifierCount = defaultOptions.defaultQuantity;
                        }

                        if (modifierCount < requiredCount) {
                            missingModifierGroups.push(modifierGroup);
                        }
                    }
                });
            }

            return {
                salesItem: salesItem,
                modifiers: item.modifiers || [],
                missingModifierGroups: missingModifierGroups,
                idx: idx
            };
        }).filter(function (item) {
            return !_.isEmpty(item.missingModifierGroups);
        }).value();
    };

    /**
     * Retrieves required modifierGroups that are missing from the input items
     *
     * @param {Array<{salesItemId: number, modifiers: array>} array of sales items and selected modifiers
     * @returns {Array<{salesItem: object, modifiers: array, missingModifierGroups: array, idx: number>} array of salesItems with corresponding missing modifiers and index position of original input
     */
    this.getMissingRequiredModifiers = function (items) {
        var items = _.cloneDeep(items);

        return _.chain(items).map(function (item, idx) {
            var salesItem = _self.getSalesItemBy(item.salesItemId);
            var missingModifierGroups = [];

            if (salesItem.modifierGroups) {
                salesItem.modifierGroups.forEach(function (modifierGroupId) {
                    var modifierGroup = _self.getModifierGroup(modifierGroupId);
                    var requiredCount = modifierGroup.minimumItems;

                    if (requiredCount > 0) {
                        var modifiers = _.filter(item.modifiers, { modifierGroupId: modifierGroupId });
                        var defaultOptions = _.find(salesItem.defaultOptions, { modifierGroupId: modifierGroupId });
                        var modifierCount = 0;

                        if (modifiers && modifiers.length) {
                            modifierCount = _.reduce(modifiers, function (sum, next) {
                                return sum + (next.quantity || 0);
                            }, 0);
                        } else if (defaultOptions) {
                            modifierCount = defaultOptions.defaultQuantity;
                        }

                        if (modifierCount < requiredCount) {
                            missingModifierGroups.push(modifierGroup);
                        }
                    }
                });
            }

            return {
                salesItem: salesItem,
                modifiers: item.modifiers || [],
                missingModifierGroups: missingModifierGroups,
                idx: idx
            };
        }).filter(function (item) {
            return !_.isEmpty(item.missingModifierGroups);
        }).value();
    };

    /**
     * Does the menu item have a combo or is it a combo?
     * @param menuItemId
     * @returns {boolean}
     */
    this.doesMenuItemHaveCombo = function (menuItemId) {
        var menuItem = _self.menuItemById(menuItemId);
        if (menuItem && menuItem.comboMenuItemId) {
            var comboMenuItem = _self.menuItemById(menuItem.comboMenuItemId);
            return _self.isMenuItemACombo(comboMenuItem);
        }
        return _self.isMenuItemACombo(menuItem);
    };

    /**
     * is the menu item a combo itself?
     * @param menuItem
     * @returns {boolean}
     */
    this.isMenuItemACombo = function (menuItem) {
        return !!(menuItem && menuItem.salesGroups && menuItem.salesGroups.length && menuItem.salesGroups.length > 0);
    };

    /**
     * Is this a stand alone combo item?  IE. kids meal or 4 for 4, where no single menu item points to this as a 'comboable'
     * item.
     * @param menuItemId
     * @returns {boolean}
     */
    this.isStandAloneComboMenuItem = function (menuItemId) {
        return !_.some(_self._wendysMenuApi.menuLists.menuItems, { comboMenuItemId: menuItemId });
    };

    this.findSalesItemByMenuItemId = function (menuItemId) {
        var menuItem = _self.menuItemById(menuItemId);
        if (!menuItem) {
            return false;
        }

        var defaultItemId = menuItem.defaultItemId;

        return _.find(_self._wendysMenuApi.menuLists.salesItems, { salesItemId: defaultItemId });
    };

    /**
     * @param defaultItemId
     * @returns {*}
     */
    this.getMenuItemByDefaultItemId = function (defaultItemId) {
        return _.find(_self._wendysMenuApi.menuLists.menuItems, { defaultItemId: defaultItemId });
    };

    /**
     * @param productId
     * @returns {*}
     */
    this.getSalesItemByProductId = function (productId) {
        return _.find(_self._wendysMenuApi.menuLists.salesItems, { productId: productId });
    };

    /**
     * Gets a nice pretty name for the UI's from a modifier 
     * @param modifierId way to find the modifier
     * @param quantity quantity of the said modifier
     * @param extendedPrice price of the said modifier
     * @returns {string}
     */
    this.getPrettyNameForModifierById = function (modifierId, actionId, quantity, extendedPrice) {
        var modifier = _self.getModifierById(modifierId);
        var name = '';

        if (modifier && modifier.displayName) {
            name = modifier.displayName;

            if (actionId && actionId !== undefined) {

                var modifierAction = _.find(this._wendysMenuApi.menuLists.modifierActions, { action: actionId });
                if (modifierAction && modifierAction.name) {

                    switch (modifierAction.name.toUpperCase()) {
                        case "NO":
                            name = 'No ' + name;
                            break;
                        case "EXTRA":
                            name = "Extra " + name;
                            break;
                        case "LIGHT":
                            name = "Light " + name;
                            break;
                        case "ADD":
                            //NO ES6 support yet in common-web :(
                            name = name + " " + (quantity ? "(x" + quantity + ")" : '');
                            break;
                    }
                }
            }
        }

        if (extendedPrice) {
            name = name + ' + $' + extendedPrice.toFixed(2).toString();
        }

        return name;
    };

    this.getComponentIdBySalesItemModifierId = function (salesItemModifierId) {
        var foundModifier = _.find(_self._wendysMenuApi.menuLists.modifiers, function (modifier) {
            if (modifier.itemModifiers && modifier.itemModifiers.length) {
                return modifier.itemModifiers[0].salesItemModifierId == salesItemModifierId;
            }
            return false;
        });
        return !_.isUndefined(foundModifier) ? foundModifier.componentId : '';
    };

    function findSubMenuById(id) {
        return _.find(_self._wendysMenuApi.menuLists.subMenus, { "subMenuId": id });
    };

    this.buildImageUrl = function buildImageUrl(productId) {
        //todo: pull this from config...
        return require('../lib/config').urls.productImageBase + productId + '.png';
    };

    function buildProportionalImageUrl(productId, size, cntry, lang) {
        var separator = '_';
        var imageUrl = productId.toString().concat(separator, size, separator, cntry, separator, lang);
        return require('../lib/config').urls.productImageBaseProportional + imageUrl + '.jpg';
    }

    function buildProductHeroImageUrl(productId) {
        //todo: pull this from config...
        return require('../lib/config').urls.productHeroImageBase + productId + '.jpg';
    };

    function buildProductProportionalHeroImageUrl(productId, size, cntry, lang) {
        var separator = '_';
        var imageUrl = productId.toString().concat(separator, size, separator, cntry, separator, lang);
        return require('../lib/config').urls.productHeroImageBaseProportional + imageUrl + '.jpg';
    }

    function buildCSOImageUrl(productId) {
        //todo: pull this from config...
        return require('../lib/config').urls.csoProductImageBase + productId + '.png';
    };

    this.getSubMenuIdForProductGroup = function (productGroupId) {
        var subMenu = false;

        var subMenus = _self._wendysMenuApi.menuLists.subMenus;
        subMenu = _.find(subMenus, function (aSubMenu) {
            return productGroupId === aSubMenu.productGroupId;
        });
        if (subMenu && subMenu.subMenuId) return subMenu.subMenuId;else return false;
    };

    this.getMenuItemForProductGroup = function (productGroupId) {
        var rawMenuItems = _self._wendysMenuApi.menuLists.menuItems;
        return _.find(rawMenuItems, function (menuItem) {
            return productGroupId === menuItem.productGroupId;
        });
    };

    this.getSubMenuFromMenuItemId = function (menuItemId) {
        var subMenus = _self._wendysMenuApi.menuLists.subMenus;
        return _.find(subMenus, function (subMenu) {
            var items = subMenu.menuItems;
            return _.find(items, function (item) {
                return item === menuItemId;
            });
        });
    };

    this.getNameByProductId = function (productId) {
        var salesItem = _self.getSalesItemByProductId(productId);
        var name = _.isUndefined(salesItem) ? false : salesItem.name;
        return name;
    };

    /**
     * Get all nested salesGroups for a menuItem
     * @returns {Array}
     * @param {Object} menuItem
     * @description returns array of nested salesGroups from a menuItem
     */
    this.getNestedSalesGroups = function (menuItem) {
        var _this = this;

        if (menuItem.salesGroups) {
            var salesGroups = _.clone(menuItem.salesGroups);
            salesGroups.map(function (salesGroup) {
                _this.parseNestedSalesGroups(salesGroup);
            });

            return salesGroups;
        }

        return [];
    };

    /**
     * Get all nested salesGroups for a menuItem's top level salesGroups
     * @returns {Array}
     * @param {Object} salesGroup
     * @description takes a top level salesGroup and forces it to be in an array if it does not have nested salesGroups
     */
    this.parseMenuItemSalesGroup = function (salesGroup) {
        return this.parseNestedSalesGroups(salesGroup, true);
    };

    /**
     * Get all nested salesGroups for any salesGroups
     * @returns {Array}
     * @param {Object} salesGroup
     * @param {boolean} isTopLevelSalesGroup
     * @description takes a salesGroup and recursively parses until it no longer finds salesGroupsIds on the salesGroup
     */
    this.parseNestedSalesGroups = function (salesGroup, isTopLevelSalesGroup) {
        var _this2 = this;

        var nestedSalesGroup = _.clone(salesGroup);
        if (nestedSalesGroup.salesGroupIds) {

            //initialize a new nestedSalesGroup
            nestedSalesGroup.nestedSalesGroups = [];

            // build basic side item choice list info?
            // no, this is the only data on the nested web salesGroup so just use what we have
            // this.buildNestedSalesGroupListItem(nestedSalesGroup);

            //salesGroupIds exist - recursively parse until we get to just salesItemIds
            var returnGroups = nestedSalesGroup.salesGroupIds.map(function (salesGroupId) {
                //get the salesGroup object for each id in the array
                var salesGroup = _this2.getSalesGroupBy(salesGroupId);

                //parse recursively and modifier by reference
                var nextNestedGroup = _this2.parseNestedSalesGroups(salesGroup, false);

                //add the salesGroup to nestedSalesGroups
                nestedSalesGroup.nestedSalesGroups.push(nextNestedGroup);

                return nextNestedGroup;
            });

            return returnGroups;
        } else if (isTopLevelSalesGroup) {
            //put top level salesGroup in an array to keep return model consistent
            return [nestedSalesGroup];
        }

        return nestedSalesGroup;
    };

    /**
     * Gets the salesItemIds array from a top level salesGroup that the provided salesItemId exists in
     * @returns {Array}
     * @param {Object} salesGroup
     * @param {number} selectedSalesItemId
     */
    this.getSizesForSelectedItemInSalesGroup = function (salesGroup, selectedSalesItemId) {
        var nestedSalesGroups = this.parseNestedSalesGroups(salesGroup);
        return this.getSizesForSelectedItemInNestedSalesGroup(nestedSalesGroups, selectedSalesItemId);
    };

    /**
     * Gets the salesItemIds array from a nested salesGroup that the provided salesItemId exists in
     * @returns {Array}
     * @param {Object} nestedSalesGroups
     * @param {number} selectedSalesItemId
     */
    this.getSizesForSelectedItemInNestedSalesGroup = function (nestedSalesGroups, selectedSalesItemId) {
        var sizes = [];
        if (_.isArray(nestedSalesGroups) && nestedSalesGroups.length > 0) {
            var currentNestedSalesGroup = _.find(nestedSalesGroups, function (el) {
                return _.includes(el.salesItemIds, selectedSalesItemId);
            });
            if (currentNestedSalesGroup) {
                sizes = currentNestedSalesGroup.salesItemIds;
            }
        }

        return sizes;
    };

    /**
     * Gets a salesGroup object from the menu by salesGroupId
     * @returns {Object}
     * @param {number} salesGroupId
     */
    this.getSalesGroupBy = function (salesGroupId) {
        return _.find(_self._wendysMenuApi.menuLists.salesGroups, { salesGroupId: salesGroupId });
    };

    /**
     * Gets a comboConfig object from the menu by comboConfigId
     * @returns {Object}
     * @param {number} comboConfigId
     */
    this.getComboConfigBy = function (comboConfigId) {
        return _.cloneDeep(_.find(_self._wendysMenuApi.menuLists.comboConfig, { comboConfigId: comboConfigId }));
    };

    this.disclaimerService = {

        disclaimers: null,

        init: function init() {
            this._checkForAvailableDisclaimers();
        },

        /**
         * Get Short Disclaimer for Nutrition
         * @returns {string}
         * @description returns disclaimer text of available; empty string otherwise
         * initial disclaimerCode keys being searched based on locale : US_ALL || CA_ALL
         */
        getNutritionShortDisclaimer: function getNutritionShortDisclaimer() {
            var shortDisclaimerKeyIdentifier = '_all';
            return this._returnDisclaimerText(shortDisclaimerKeyIdentifier);
        },

        /**
         * Get Long Disclaimer for Nutrition
         * @returns {string}
         * @description returns disclaimer text of available; empty string otherwise
         * initial disclaimerCode keys being searched based on locale : US_REST || CA_REST
         */
        getNutritionLongDisclaimer: function getNutritionLongDisclaimer() {
            var longDisclaimerKeyIdentifier = '_rest';
            return this._returnDisclaimerText(longDisclaimerKeyIdentifier);
        },

        /**
         * Get Sodium Disclaimer for Nutrition
         * @returns {object}
         * @description returns sodium disclaimer of available; undefined otherwise
         */
        getSodiumDisclaimer: function getSodiumDisclaimer() {
            return this._getDisclaimerByKey('disclaimerCode', "sodium");
        },

        /**
         * Get disclaimerText based on disclaimerKey
         * @param disclaimerKey
         * @returns {string}
         * @private
         */
        _returnDisclaimerText: function _returnDisclaimerText(disclaimerKey) {
            if (this.disclaimers === null || this.disclaimers.length === 0) {
                return '';
            }
            /* locate disclaimer in array collection by disclaimerCode key */
            var disclaimer = this._getDisclaimerByKey('disclaimerCode', disclaimerKey);
            return disclaimer !== undefined && disclaimer.hasOwnProperty('disclaimerText') ? disclaimer.disclaimerText : '';
        },

        /**
         * Check for disclaimers availability
         * @private
         */
        _checkForAvailableDisclaimers: function _checkForAvailableDisclaimers() {
            if (Array.isArray(this.disclaimers) && this.disclaimers.length) return;

            var meunLists = _self._wendysMenuApi.menuLists;
            var disclaimersAvailable = meunLists.hasOwnProperty('disclaimers') && Array.isArray(meunLists.disclaimers);
            if (disclaimersAvailable) this.disclaimers = meunLists.disclaimers;
        },

        /**
         * Get disclaimer by key
         * @param key
         * @param keyValue
         * @returns {*}
         * @private
         * @description returns object for key if exists; undefined otherwise
         * To make as extensible as possible, the key value is simply the '_all'
         * or '_rest' suffix of the disclaimerCode key value; will pull the appropriate
         * disclaimer object regardless of locale (e.g. where disclaimerCode = US_ALL, CA_ALL, [FUTURE]_ALL etc.)
         */
        _getDisclaimerByKey: function _getDisclaimerByKey(key, keyValue) {
            var _this3 = this;

            var disclaimer = _.find(this.disclaimers, function (_disclaimer) {
                if (_disclaimer[key].toLowerCase().indexOf(keyValue) !== -1) {
                    return _.find(_this3.disclaimers, [key, _disclaimer[key]]);
                }
            });

            return disclaimer;
        },

        /**
         * Get requires meat disclaimer for Nutrition
         * @param menuItem
         * @returns { Boolean }
         * @description returns true if menu item requires meat disclaimer; false if otherwise
         */
        requiresMeatDisclaimer: function requiresMeatDisclaimer(menuItem) {
            if (!menuItem || !menuItem.description || menuItem.description.length === 0) {
                return false;
            }

            var meatMatch = menuItem.description.match(/beef|boeuf|carne|hamburger|hamburger|hamburguesa/i);
            var quantityMatch0 = menuItem.description.match(/(1\/2|[13]\/4|¼|½|¾)\s*lb/i);
            var quantityMatchEn1 = menuItem.description.match(/(quarter|half|three(-| )quarters)\s*-*[of a]*pound/i);
            var quantityMatchFr1 = menuItem.description.match(/(quart(s*)|demi)\s*-*[de\s]*livre/i);
            var quantityMatchEs1 = menuItem.description.match(/(cuarto(s*)|con media)[\sde\s]*-*libra/i);

            return !!(meatMatch && (quantityMatch0 || quantityMatchEn1 || quantityMatchFr1 || quantityMatchEs1));
        }
    };

    this.isContextExpired = function () {
        if (!this._wendysMenuApi.hasOwnProperty('menuLists') || !this._wendysMenuApi.menuLists.hasOwnProperty('cacheExpirationDate')) return true;

        return new Date(this._wendysMenuApi.menuLists.cacheExpirationDate) <= new Date();
    };

    this.etag = '';

    this.setETag = function (headers) {
        this.etag = !!headers && headers.hasOwnProperty('ETag') && headers.ETag !== '' ? "\"" + headers.ETag + "\"" : '';
    };

    /* property initialization */
    attemptFixOfSalesItems(_self._wendysMenuApi.menuLists.salesItems);

    if (wendysMenuApi.hasOwnProperty('headers')) this.setETag(wendysMenuApi.headers);

    this.disclaimerService.init();
};

function attemptFixOfSalesItems(salesItems) {
    try {
        _.forEach(salesItems, function (salesItem) {
            if (_.isUndefined(salesItem.displayName)) {
                salesItem.displayName = salesItem.name;
            }
        });
    } catch (error) {
        console.log("attemptFixOfSalesItems error", error);
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/models/menuModel.js
// module id = 836
// module chunks = 0